import React, {useCallback, useEffect, useRef} from 'react';
import {Player, TextComponent} from '@galacean/effects';
import {useSequentialModalContext} from '@basicComponents/sequential-modal/context';
import {toPriceStr} from '@components/utils';
import {times} from '@components/utils/number-precision';

const sourceBtn = '/assets/下载引导奖励 _btn_start/下载引导奖励_btn_start.json';
const sourceVip = '/assets/下载引导奖励 _vip/下载引导奖励 _vip.json';
const sourceBase = '/assets/下载引导奖励 _start/下载引导奖励_start.json';

interface DownAppModalProps {
  baseAmount?: number;
  totalAmount?: number;
  vipBonusAmount?: number;
  vipBonusRate?: number;
  vipLevel?: number;
}

// 回到app领取奖励
export const DOWNLOAD_GET_REWARD = 'DOWNLOAD_GET_REWARD';

export default function RewardSuccess(props: DownAppModalProps) {
  const {baseAmount, vipBonusRate = 0, totalAmount} = props;
  const playerRef = useRef<Player | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const {goToNext} = useSequentialModalContext();
  const entry = useCallback(async () => {
    const player = playerRef.current;
    if (!player) {
      return;
    }

    try {
      player
        .loadScene([
          {
            url: sourceBtn,
          },
          {
            url: sourceBase,
            options: {
              variables: {
                num: toPriceStr(baseAmount, {fixed: 0, round: 'floor'}),
              },
            },
          },
          {
            url: sourceVip,
            options: {
              autoplay: false,
              variables: {
                num: toPriceStr(totalAmount, {fixed: 0, round: 'floor'}),
              },
            },
          },
        ])
        .then(([btn, _, vip]) => {
          const beishu = vip?.getItemByName('beishu');
          const text = beishu?.getComponent(TextComponent);
          const bonus = vip?.getItemByName('num%');
          const textBonus = bonus?.getComponent(TextComponent);
          textBonus?.setText(`VIP bonus:+${times(vipBonusRate, 100)}%`);
          text?.setText(times(vipBonusRate, 100) + '%');
          btn.on('click', () => {
            player.dispose();
            goToNext();
          });
          setTimeout(() => {
            vip.play();
          }, 1000);
        });

      player.play();
    } catch (error) {
      console.error('Failed to load scene:', error);
    }
  }, [baseAmount, goToNext, totalAmount, vipBonusRate]);

  useEffect(() => {
    if (playerRef.current) {
      return;
    }

    const container = containerRef.current;
    if (!container) {
      return;
    }

    const player = new Player({
      container,
      interactive: true,
    });

    playerRef.current = player;

    const handleResize = () => {
      player.resize();
    };

    window.addEventListener('resize', handleResize);
    entry().catch(console.error);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [entry]);
  return (
    <div className="relative">
      <div ref={containerRef} className="w-screen h-screen" />
    </div>
  );
}
